export default {
  paragraphs: [
    "If the transaction involves a currency conversion, the following webhook will be triggered after the previous one (type: identified). It will be sent either once the exchange has been successfully created by our operations team, or automatically right after the identified notification if you have automatic exchange enabled.",
    "Note that a single exchange can be associated with multiple transactions if they share the same subject and destination account. For this reason, you will receive a list of transaction IDs in the transaction_ids field."
  ],
  path: "notification_exchange_created",
  request: {
    method: "POST",
    payloads: [
      {
        title: "Notification",
        content: {
          "notification": {
            "type": "exchange_created",
            "exchange_id": "some_uuid",
            "transaction_ids":
              [
                "transaction-id-a",
                "transaction-id-b"
              ],
            "secret": "the value you received"
          }
        }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/NotificationExchange.js